import { Box, Paper, Skeleton, Typography } from "@mui/material";

type Props = {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  isLoading: boolean;
};

export const KpiCard = ({
  title,
  value,
  icon,
  isLoading,
}: Props): React.ReactNode => {
  return (
    <Paper
      sx={{
        bgcolor: "background.default",
        border: (theme) => `1px solid ${theme.colors.border}`,
        borderRadius: 2,
        p: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
      elevation={0}
    >
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: (theme) => `${theme.palette.primary.main}26`,
          color: "primary.main",
          mb: 3,
        }}
      >
        {icon}
      </Box>

      {isLoading ? (
        <Skeleton width={80} height={40} sx={{ bgcolor: "action.hover" }} />
      ) : (
        <Typography
          variant="h4"
          fontWeight={700}
          color="text.primary"
          textAlign="center"
        >
          {value}
        </Typography>
      )}

      <Typography variant="body2" color="text.secondary" textAlign="center">
        {title}
      </Typography>
    </Paper>
  );
};
